export default __webpack_public_path__ + "static/media/Mirrored-Glass-Truck-Hero-1920px-640px.jpg.b8197f3d.webp";